import React from 'react';
import { FiHardDrive, FiUploadCloud } from 'react-icons/fi';

function formatBytes(bytes) {
  if (!bytes) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB'];
  let value = bytes;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex++;
  }
  return `${value.toFixed(value >= 10 || unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`;
}

function formatRelativeTime(dateStr) {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  if (diffMins < 60) return `${diffMins}m ago`;
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours}h ago`;
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 30) return `${diffDays}d ago`;
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export default function StorageCard({ stats, uploadsAlbum, onUploadClick }) {
  const isEmpty = !stats || stats.total_files === 0;

  return (
    <div className="ws-card">
      <div className="ws-card-header">
        <h4><FiHardDrive size={15} /> Storage</h4>
        {!isEmpty && (
          <button className="ws-card-action" onClick={onUploadClick}>
            <FiUploadCloud size={13} /> Upload
          </button>
        )}
      </div>

      {isEmpty ? (
        <div className="ws-card-empty">
          <FiUploadCloud size={32} />
          <p>No files uploaded yet</p>
          <button className="cta-btn" onClick={onUploadClick}>Upload Photos</button>
        </div>
      ) : (
        <div className="ws-card-body">
          <div className="storage-stats-row">
            <div className="storage-stat">
              <span className="stat-value">{stats.total_files.toLocaleString()}</span>
              <span className="stat-label">Files</span>
            </div>
            <div className="storage-stat">
              <span className="stat-value">{formatBytes(stats.total_bytes)}</span>
              <span className="stat-label">Total Size</span>
            </div>
          </div>

          <div className="storage-breakdown">
            {stats.raw_count > 0 && <span className="type-pill raw">{stats.raw_count} RAW</span>}
            {stats.jpeg_count > 0 && <span className="type-pill jpeg">{stats.jpeg_count} JPEG</span>}
            {stats.video_count > 0 && <span className="type-pill video">{stats.video_count} Video</span>}
          </div>

          {stats.latest_upload && (
            <div className="storage-meta">
              Last upload {formatRelativeTime(stats.latest_upload)}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
